exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt-4-5 {\n  margin-top: 2rem !important;\n}\n.table-bordered thead th, .table-bordered thead td , .table-bordered tbody td, .table-bordered tbody span{\n  vertical-align: middle;\n  font-size: 12px;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2fcf5c50","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/Products/ChangePrice.vue
// module id = xtuD
// module chunks = 4